module.exports = __webpack_public_path__ + "static/media/mimlogo.0ed572ce.png";